module.exports = __webpack_public_path__ + "static/img/7.f317d26.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/zh/7.png
// module id = uI4B
// module chunks = 0